module.exports = __webpack_public_path__ + "fonts/lato-semibold-latin.901549f.woff";